import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateId } from '@ztechapps/common.utils'

@ObjectType()
export class StripeAchCreditTransfer {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateId() })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  accountNumber: string

  @Field(() => String)
  @Prop({ type: String })
  routingNumber: string

  @Field(() => String)
  @Prop({ type: String })
  bankName: string

  @Field(() => String)
  @Prop({ type: String })
  swiftCode: string

  @Field(() => String)
  @Prop({ type: String })
  email: string
}
